import { bind, unwrap, toArray as toArray_1, map, defaultArg } from "../../fable_modules/fable-library-js.4.19.3/Option.js";
import { Permission, isAllowed } from "../../RAWMap.Models/Security.js";
import { safeHash, int32ToString, equals } from "../../fable_modules/fable-library-js.4.19.3/Util.js";
import { InstitutionClinicalDesignation } from "../../RAWMap.Models/View/Institution.js";
import { mkToolReactButton, mkDispatchLocal } from "../Common/CommonView.js";
import { FormField_labeledSlider, FormField_onChangeNumberDispatch, FormField_ReactSelectCallback$1, FormField_reactSelectSingle } from "../../Common/Forms.js";
import { SelectPropsMulti$1 } from "../../Common/ReactSelectBind.js";
import { ImageData_LumenMasks__43A3F7B7, ImageData_VisceralMasks__43A3F7B7, ImageData_WallMasks__43A3F7B7, ImageData_StandardImageFiles__43A3F7B7, DicomViewMode, ViewportLocation, Meshes_Previous_3B5CE845, Meshes_Current_3B5CE845, TargetStudy, InteractionMsg, CardMode, ActiveSegmentation_get_describe, ActiveSegmentation, ActiveSegmentation_get_all, VisualizationType, MeshViewportLocation, DisplayMap_describe } from "../Common/CommonTypes.js";
import { Compare_previousMeshTypes, Compare_previousStudyViewport, VisualizationViewMode_toInteractionMode_Z71EA20FE, OutboundMsg, ModelVisualizationTemp__get_hasModifiedSegmentations, VisualizationViewMode, LocalMsg } from "./VisualizationTempTypes.js";
import * as react from "react";
import { keyValueList } from "../../fable_modules/fable-library-js.4.19.3/MapUtil.js";
import { Button_visibilityControlled, ComponentVisibility } from "../../Common/Controls.js";
import { Header_icon, Header_title, header, content as content_1, card } from "../../fable_modules/Fulma.3.0.0/Components/Card.fs.js";
import { map as map_1, contains, toArray, ofArray, singleton, empty } from "../../fable_modules/fable-library-js.4.19.3/List.js";
import { Size_ISize, Color_IColor, Common_GenericOption } from "../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { button, Option } from "../../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { CSSProp, DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { lockUnlockTool as lockUnlockTool_1 } from "../Camera/CameraView.js";
import { Shared_onButtonStyles, Shared_defaultButtonStyles } from "../VisualizationShared.js";
import { Fa_IconOption } from "../../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { Helpers_nothing } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { VisualizationTempInteractionMode, InteractionMode, CommonInteractionMode } from "../Common/CommonBindings.js";
import { screenshotModal, takeScreenshotTool, cancelScreenshotTool } from "../Screenshot/ScreenshotView.js";
import { showSlicePlaneTool } from "../SlicePlane/SlicePlaneView.js";
import { Controls_spinner, Controls_dropdownButton, Forms_formFieldReactSelect } from "../../Common/General.js";
import { append, empty as empty_1, singleton as singleton_1, delay, toList } from "../../fable_modules/fable-library-js.4.19.3/Seq.js";
import { LengthPropsModel, SlicingMode, eventNames, InteractionModeProps, SegmentationPaintingMode } from "../VisualizationBindings.js";
import { body, Label_Option, label, Option as Option_1, div } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Field.fs.js";
import { Option as Option_2 } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { printf, toText } from "../../fable_modules/fable-library-js.4.19.3/String.js";
import { wrapInboundMsg, wrapLocalMsg, wrapOutboundMsg } from "../../Common/InboundOutbound.js";
import { Level_Option, level } from "../../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { Option as Option_3, tag as tag_52 } from "../../fable_modules/Fulma.3.0.0/Elements/Tag.fs.js";
import { ModelCenterlineMeasurement_Props, LocalMsg as LocalMsg_1 } from "../CenterlineMeasurement/CenterlineMeasurementTypes.js";
import { ModelCalipers_Props_69A04C54, LocalMsg as LocalMsg_2 } from "../Calipers/CalipersTypes.js";
import { deleteMeasurementModal, makeAllMeasurementCards } from "../MeasurementsView.js";
import { notesModal, notesCard } from "../Notes/NotesView.js";
import { TableOption, table as table_1 } from "../../fable_modules/Fulma.3.0.0/Elements/Table.fs.js";
import { Option as Option_4, icon as icon_12 } from "../../fable_modules/Fulma.3.0.0/Elements/Icon.fs.js";
import { ModelSlicePlane_Props_Z714BB56C, InboundMsg } from "../SlicePlane/SlicePlaneTypes.js";
import { toArray as toArray_2, FSharpMap__get_Item } from "../../fable_modules/fable-library-js.4.19.3/Map.js";
import { NotesProps, StaticLabel } from "../Notes/NotesBindings.js";
import { ModelNotes__Props_25828286 } from "../Notes/NotesTypes.js";
import { append as append_1 } from "../../fable_modules/fable-library-js.4.19.3/Array.js";
import { toString } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { ModelCamera_Props } from "../Camera/CameraTypes.js";
import { ModelScreenshot_Props_Z625F521 } from "../Screenshot/ScreenshotTypes.js";
import { ModelAnatomyOrientation_Props_Z550008EC } from "../AnatomyOrientation/AnatomyOrientationTypes.js";
import { ModelPickedMapValue_Props } from "../PickedMapValue/PickedMapValueTypes.js";
import MeshVisualization from "../../../../src/RAWMap.Client/Visualization/js/MeshVisualization.js";
import DicomVisualization from "../../../../src/RAWMap.Client/Visualization/js/DicomVisualization.js";
import { Card_foot, Card_body, Card_head, Card_card, background, Option as Option_5, modal } from "../../fable_modules/Fulma.3.0.0/Components/Modal.fs.js";
import { mkManagedUpload } from "./VisualizationTempState.js";
import { Common_StudyStatus } from "../../RAWMap.Models/Common.js";
import { content as content_2 } from "../../fable_modules/Fulma.3.0.0/Elements/Content.fs.js";

export function canUserViewCustomReport(model) {
    return defaultArg(map((user) => isAllowed(new Permission(20, []))(user.roles), model.MaybeCurrentUser), false);
}

export function canUserEditCustomReportData(model) {
    return defaultArg(map((user) => isAllowed(new Permission(21, []))(user.roles), model.MaybeCurrentUser), false);
}

export function canUserApproveSegmentation(model) {
    return defaultArg(map((user) => isAllowed(new Permission(28, []))(user.roles), model.MaybeCurrentUser), false);
}

function areMapSelectorsVisible(model) {
    if (model.PatientInstitutionDesignation.tag === 0) {
        return true;
    }
    else {
        return model.IsSegmentationApproved;
    }
}

function isApprovalGateActive(model) {
    if ((equals(model.PatientInstitutionDesignation, new InstitutionClinicalDesignation(1, [])) && !model.IsSegmentationApproved) && model.SegmentationApprovalPromptShown) {
        return !model.SegmentationApprovalModalVisible;
    }
    else {
        return false;
    }
}

function mkMapSelect(dispatch, viewPort, viewMode, maps, selectedMap) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    const props = [["style", {
        minWidth: "150px",
    }]];
    const children = [FormField_reactSelectSingle(maps, [], [new SelectPropsMulti$1(10, [false]), new SelectPropsMulti$1(11, ["auto"]), new SelectPropsMulti$1(12, ["fixed"])], DisplayMap_describe, selectedMap, new FormField_ReactSelectCallback$1((maybeNewValue) => {
        if (maybeNewValue == null) {
        }
        else {
            dispatchLocal(new LocalMsg(4, [viewPort, maybeNewValue]));
        }
    }), "", [])];
    return react.createElement("div", keyValueList(props, 1), ...children);
}

function mkViewportToolPanel(children) {
    const props = [["style", {
        position: "absolute",
        top: "8px",
        left: "8px",
    }]];
    return react.createElement("div", keyValueList(props, 1), ...children);
}

/**
 * Sidebar card offering the segmentation approval, shown only while the approval gate is active.
 */
export function approveSegmentationCardOption(model, dispatch) {
    if (isApprovalGateActive(model)) {
        const visibility = canUserApproveSegmentation(model) ? (new ComponentVisibility(0, [])) : (new ComponentVisibility(2, ["You do not have permission to approve segmentations."]));
        return singleton(card(empty(), singleton(content_1(singleton(new Common_GenericOption(1, [singleton(["style", {
            padding: "0.5rem 1rem",
            margin: "1rem 0",
        }])])), singleton(Button_visibilityControlled(undefined, visibility, ofArray([new Option(0, [new Color_IColor(6, [])]), new Option(2, []), new Option(17, [ofArray([new HTMLAttr(99, ["approveSegmentation"]), new HTMLAttr(158, ["Approve the existing segmentation to view the other visualization maps"]), new HTMLAttr(159, ["button"]), new DOMAttr(40, [(_arg) => {
            dispatch(new LocalMsg(42, []));
        }])])])]), singleton("Approve Segmentation")))))));
    }
    else {
        return undefined;
    }
}

function mkMainToolPanel(imageData, model, dispatch) {
    let isOn, isOn_1;
    const dispatchLocal = mkDispatchLocal(dispatch);
    let isToolPanelDisabled;
    const matchValue = model.InteractionMode;
    let matchResult;
    if (matchValue.tag === 0) {
        if (matchValue.fields[0].tag === 0) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            isToolPanelDisabled = false;
            break;
        }
        default:
            isToolPanelDisabled = true;
    }
    const lockUnlockTool = lockUnlockTool_1(isToolPanelDisabled, model.CameraModel, (arg) => {
        dispatchLocal(new LocalMsg(12, [arg]));
    });
    let viewModeTool;
    const matchValue_1 = model.ViewMode;
    viewModeTool = ((matchValue_1.tag === 2) ? mkToolReactButton(dispatch, Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-square"]), new LocalMsg(6, [new VisualizationViewMode(1, [new VisualizationType(0, [new MeshViewportLocation(0, [])])])]), false, isToolPanelDisabled, "Switch to single view") : ((matchValue_1.tag === 0) ? mkToolReactButton(dispatch, Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-square"]), new LocalMsg(6, [new VisualizationViewMode(1, [new VisualizationType(0, [new MeshViewportLocation(0, [])])])]), false, true, "Unable to switch views when comparing previous study") : mkToolReactButton(dispatch, Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-th-large"]), new LocalMsg(6, [new VisualizationViewMode(2, [])]), false, isToolPanelDisabled, "Switch to quad view")));
    let singleViewTool;
    const matchValue_2 = model.ViewMode;
    singleViewTool = ((matchValue_2.tag === 1) ? ((matchValue_2.fields[0].tag === 0) ? mkToolReactButton(dispatch, Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-brain"]), new LocalMsg(6, [new VisualizationViewMode(1, [new VisualizationType(1, [])])]), false, isToolPanelDisabled, "Show CT slice") : mkToolReactButton(dispatch, Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-cube"]), new LocalMsg(6, [new VisualizationViewMode(1, [new VisualizationType(0, [new MeshViewportLocation(0, [])])])]), false, isToolPanelDisabled, "Show single map")) : Helpers_nothing);
    const patternInput = (model.IsFollowupStudy && model.HasPreviousStudyMaps) ? [(isOn = model.DisplayPreviousStudyMaps, mkToolReactButton(dispatch, isOn ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-history"]), new LocalMsg(10, [!isOn]), false, isToolPanelDisabled, ((_arg) => {
        if (_arg) {
            return "Hide previous study maps";
        }
        else {
            return "Overlay previous study maps";
        }
    })(isOn))), (isOn_1 = equals(model.ViewMode, new VisualizationViewMode(0, [])), mkToolReactButton(dispatch, isOn_1 ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-clone"]), new LocalMsg(6, [(model.ViewMode.tag === 0) ? (new VisualizationViewMode(2, [])) : (new VisualizationViewMode(0, []))]), false, isToolPanelDisabled, ((_arg_1) => {
        if (_arg_1) {
            return "Stop comparing previous study maps";
        }
        else {
            return "Compare with previous study maps";
        }
    })(isOn_1)))] : [Helpers_nothing, Helpers_nothing];
    let isReportsButtonDisabled;
    const matchValue_4 = model.InteractionMode;
    const matchValue_5 = !canUserViewCustomReport(model);
    const matchValue_6 = ModelVisualizationTemp__get_hasModifiedSegmentations(model);
    let matchResult_1;
    if (matchValue_4.tag === 0) {
        if (matchValue_4.fields[0].tag === 0) {
            if (matchValue_5) {
                matchResult_1 = 1;
            }
            else if (matchValue_6) {
                matchResult_1 = 1;
            }
            else {
                matchResult_1 = 0;
            }
        }
        else {
            matchResult_1 = 1;
        }
    }
    else {
        matchResult_1 = 1;
    }
    switch (matchResult_1) {
        case 0: {
            isReportsButtonDisabled = false;
            break;
        }
        default:
            isReportsButtonDisabled = true;
    }
    let isScreenshotButtonDisabled;
    const matchValue_8 = model.InteractionMode;
    const matchValue_9 = !canUserEditCustomReportData(model);
    const matchValue_10 = ModelVisualizationTemp__get_hasModifiedSegmentations(model);
    let matchResult_2;
    if (matchValue_8.tag === 0) {
        if (matchValue_8.fields[0].tag === 0) {
            if (matchValue_9) {
                matchResult_2 = 1;
            }
            else if (matchValue_10) {
                matchResult_2 = 1;
            }
            else {
                matchResult_2 = 0;
            }
        }
        else {
            matchResult_2 = 1;
        }
    }
    else {
        matchResult_2 = 1;
    }
    switch (matchResult_2) {
        case 0: {
            isScreenshotButtonDisabled = false;
            break;
        }
        default:
            isScreenshotButtonDisabled = true;
    }
    const screenshotTool = (isScreenshotButtonDisabled && equals(model.InteractionMode, new InteractionMode(0, [new CommonInteractionMode(1, [])]))) ? cancelScreenshotTool(false, (arg_1) => {
        dispatchLocal(new LocalMsg(15, [arg_1]));
    }) : takeScreenshotTool(isScreenshotButtonDisabled, (arg_2) => {
        dispatchLocal(new LocalMsg(15, [arg_2]));
    });
    const slicePlaneTool = showSlicePlaneTool(false, model.SlicePlaneModel, (arg_3) => {
        dispatchLocal(new LocalMsg(16, [arg_3]));
    });
    const helpTool = mkToolReactButton(dispatch, model.ShowHelpTooltip ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-question-circle"]), new LocalMsg(20, []), false, false, "Help with controls");
    const windowLevelButton = mkToolReactButton(dispatch, !model.ShowMasks ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(15, ["fas fa-circle-half-stroke"]), new LocalMsg(21, [!model.ShowMasks]), false, false, "Adjust Window/Level");
    const segmentationEditAllowed = equals(model.InteractionMode, new InteractionMode(0, [new CommonInteractionMode(0, [])]));
    let segmentationEnableButton;
    let segmentationAllowed;
    const matchValue_12 = model.ViewMode;
    let matchResult_3;
    switch (matchValue_12.tag) {
        case 1: {
            if (matchValue_12.fields[0].tag === 1) {
                matchResult_3 = 0;
            }
            else {
                matchResult_3 = 1;
            }
            break;
        }
        case 2: {
            matchResult_3 = 0;
            break;
        }
        default:
            matchResult_3 = 1;
    }
    switch (matchResult_3) {
        case 0: {
            segmentationAllowed = true;
            break;
        }
        default:
            segmentationAllowed = false;
    }
    const hasUnsavedSegmentations = ModelVisualizationTemp__get_hasModifiedSegmentations(model) && !model.ReanalysisSubmitted;
    const patternInput_1 = !segmentationAllowed ? ["Segmentation is not available for this view", true] : (model.SegmentationModeEnabled ? ["Disable Segmentation", false] : ["Enable Segmentation", false]);
    segmentationEnableButton = mkToolReactButton(dispatch, model.SegmentationModeEnabled ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(15, ["fas fa-draw-polygon"]), model.SegmentationModeEnabled ? (hasUnsavedSegmentations ? (new LocalMsg(39, [true])) : (new LocalMsg(40, []))) : (new LocalMsg(22, [])), false, patternInput_1[1], patternInput_1[0]);
    let segmentationSelect;
    const visceralFiles = (imageData == null) ? [] : imageData.VisceralMasks;
    const props = [["style", {
        display: "inline-block",
        marginTop: "0",
        marginBottom: "0",
    }]];
    const children = [Forms_formFieldReactSelect([new SelectPropsMulti$1(10, [false]), new SelectPropsMulti$1(11, ["auto"]), new SelectPropsMulti$1(12, ["fixed"])], "", model.ActiveSegmentation, ActiveSegmentation_get_all(), toList(delay(() => ((visceralFiles.length === 0) ? singleton_1(new ActiveSegmentation(2, [])) : empty_1()))), ActiveSegmentation_get_describe(), (arg_4) => {
        dispatchLocal(new LocalMsg(31, [arg_4]));
    })];
    segmentationSelect = react.createElement("div", keyValueList(props, 1), ...children);
    const mkPaintingModeToggle = (mode, icon_10, toolDescription) => {
        let tupledArg;
        const isActive = model.SegmentationProps.paintingEnabled && equals(model.SegmentationProps.paintingMode, mode);
        let patternInput_2;
        const matchValue_15 = model.ViewMode;
        let matchResult_4;
        switch (matchValue_15.tag) {
            case 1: {
                if (matchValue_15.fields[0].tag === 1) {
                    matchResult_4 = 0;
                }
                else {
                    matchResult_4 = 1;
                }
                break;
            }
            case 2: {
                matchResult_4 = 0;
                break;
            }
            default:
                matchResult_4 = 1;
        }
        switch (matchResult_4) {
            case 0: {
                patternInput_2 = [isActive ? (`Disable ${toolDescription}`) : (`Enable ${toolDescription}`), false];
                break;
            }
            default:
                patternInput_2 = [`The ${toolDescription} is not available for this view`, true];
        }
        return mkToolReactButton(dispatch, isActive ? Shared_onButtonStyles : Shared_defaultButtonStyles, icon_10, (tupledArg = [!isActive, mode], new LocalMsg(23, [tupledArg[0], tupledArg[1]])), false, patternInput_2[1] ? true : !segmentationEditAllowed, patternInput_2[0]);
    };
    const paintBrushToggle = mkPaintingModeToggle(new SegmentationPaintingMode(1, []), new Fa_IconOption(15, ["fas fa-paintbrush"]), "segmentation painter");
    const paintEraseToggle = mkPaintingModeToggle(new SegmentationPaintingMode(2, []), new Fa_IconOption(15, ["fas fa-eraser"]), "segmentation eraser");
    const makeHorizontalField = (givenLabel, width, contents) => div(ofArray([new Option_1(10, ["horizontal-field"]), new Option_1(8, []), new Option_1(11, [singleton(["style", {
        margin: "0 0.25em 0 0",
        alignItems: "center",
    }])])]), ofArray([label(ofArray([new Label_Option(1, []), new Label_Option(3, [singleton(["style", {
        flexBasis: width,
        flexGrow: "0",
        margin: "0",
    }])])]), singleton(react.createElement("label", {}, givenLabel))), body(empty(), singleton(contents))]));
    let brushSizeSlider;
    if (model.SegmentationProps.paintingEnabled) {
        const callback = FormField_onChangeNumberDispatch((maybeNumber) => {
            defaultArg(map((number) => {
                dispatchLocal(new LocalMsg(24, [number]));
            }, maybeNumber), undefined);
        }, model.SegmentationProps.paintingBrushSize);
        brushSizeSlider = makeHorizontalField("Brush Size", "6em", FormField_labeledSlider(1, 50, 1, int32ToString(model.SegmentationProps.paintingBrushSize), [new HTMLAttr(64, ["horizontal-slider"])], [new Option_2(15, [ofArray([new HTMLAttr(158, [`${model.SegmentationProps.paintingBrushSize} px`]), ["style", {
            width: "7em",
        }]])])], callback, "", []));
    }
    else {
        brushSizeSlider = Helpers_nothing;
    }
    let segmentationOpacitySlider;
    let opacityValueTooltip;
    const arg_5 = ~~(model.SegmentationProps.segmentationOpacity * 100) | 0;
    opacityValueTooltip = toText(printf("%d%%"))(arg_5);
    const callback_1 = FormField_onChangeNumberDispatch((maybeNumber_1) => {
        defaultArg(map((number_1) => {
            dispatchLocal(new LocalMsg(25, [number_1]));
        }, maybeNumber_1), undefined);
    }, model.SegmentationProps.segmentationOpacity);
    segmentationOpacitySlider = makeHorizontalField("Opacity", "4em", FormField_labeledSlider(0, 1, 0.05, model.SegmentationProps.segmentationOpacity.toString(), [new HTMLAttr(64, ["horizontal-slider"])], [new Option_2(15, [ofArray([new HTMLAttr(158, [opacityValueTooltip]), ["style", {
        width: "7em",
    }]])])], callback_1, "", []));
    let zoomScrollToggle;
    let patternInput_3;
    const matchValue_16 = model.ViewMode;
    const matchValue_17 = model.IsSliceScroll;
    let matchResult_5;
    switch (matchValue_16.tag) {
        case 1: {
            if (matchValue_16.fields[0].tag === 1) {
                if (matchValue_17) {
                    matchResult_5 = 0;
                }
                else {
                    matchResult_5 = 1;
                }
            }
            else {
                matchResult_5 = 2;
            }
            break;
        }
        case 2: {
            if (matchValue_17) {
                matchResult_5 = 0;
            }
            else {
                matchResult_5 = 1;
            }
            break;
        }
        default:
            matchResult_5 = 2;
    }
    switch (matchResult_5) {
        case 0: {
            patternInput_3 = ["Switch mouse wheel action to Zoom", new Fa_IconOption(15, ["fas fa-magnifying-glass"]), false];
            break;
        }
        case 1: {
            patternInput_3 = ["Switch mouse wheel action to Scroll CT Slices", new Fa_IconOption(15, ["fas fa-arrow-down-up-across-line"]), false];
            break;
        }
        default:
            patternInput_3 = ["Scrolling is not available in for this view", new Fa_IconOption(15, ["fas fa-arrow-down-up-across-line"]), true];
    }
    zoomScrollToggle = mkToolReactButton(dispatch, Shared_defaultButtonStyles, patternInput_3[1], new LocalMsg(7, [!model.IsSliceScroll]), false, patternInput_3[2], patternInput_3[0]);
    const backToStudyButton = button(ofArray([new Option(0, [new Color_IColor(6, [])]), new Option(16, [isToolPanelDisabled]), new Option(17, [ofArray([new HTMLAttr(99, ["backToStudy"]), new DOMAttr(40, [(_arg_3) => {
        dispatch(wrapOutboundMsg(new OutboundMsg(2, [])));
    }])])])]), singleton("Back to Study"));
    let customReportButton;
    const handler = (model.PatientInstitutionDesignation.tag === 1) ? ((_arg_5) => {
        dispatchLocal(new LocalMsg(44, [true]));
    }) : ((_arg_4) => {
        dispatch(wrapOutboundMsg(new OutboundMsg(1, [model.SelectedStudy, model.CustomReportData])));
    });
    customReportButton = button(ofArray([new Option(0, [new Color_IColor(6, [])]), new Option(16, [isReportsButtonDisabled]), new Option(17, [ofArray([["style", {
        marginLeft: 5,
    }], new DOMAttr(40, [handler])])])]), singleton("Generate Report"));
    const submitForReanalysisButton = button(ofArray([new Option(17, [singleton(["style", {
        marginLeft: "auto",
    }])]), new Option(0, [new Color_IColor(7, [])]), new Option(16, [(isToolPanelDisabled ? true : model.ReanalysisSubmitted) ? true : !ModelVisualizationTemp__get_hasModifiedSegmentations(model)]), new Option(17, [ofArray([new HTMLAttr(99, ["submitForReanalysis"]), new DOMAttr(40, [(_arg_6) => {
        dispatch(wrapLocalMsg(new LocalMsg(33, [true])));
    }])])])]), singleton("Submit for Reanalysis"));
    let verticalDivider;
    const props_4 = [new HTMLAttr(64, ["is-divider"]), ["style", {
        width: "1px",
        backgroundColor: "#ccc",
        marginLeft: "0.5rem",
        marginRight: "0.5rem",
    }]];
    verticalDivider = react.createElement("div", keyValueList(props_4, 1));
    const group = (elements) => level(singleton(new Level_Option(0, [singleton(["style", {
        marginBottom: 0,
    }])])), elements);
    const children_6 = toList(delay(() => append(singleton_1(group(ofArray([backToStudyButton, customReportButton]))), delay(() => append(singleton_1(group(ofArray([helpTool, lockUnlockTool, viewModeTool, singleViewTool, screenshotTool, slicePlaneTool, patternInput[1], zoomScrollToggle]))), delay(() => append(equals(model.PatientInstitutionDesignation, new InstitutionClinicalDesignation(1, [])) ? append(singleton_1(group(singleton(windowLevelButton))), delay(() => append(singleton_1(verticalDivider), delay(() => append(singleton_1(group(singleton(segmentationEnableButton))), delay(() => ((model.SegmentationModeEnabled && model.SegLockWarningShown) ? singleton_1(group(ofArray([segmentationSelect, segmentationOpacitySlider, paintBrushToggle, paintEraseToggle, brushSizeSlider]))) : empty_1()))))))) : empty_1(), delay(() => {
        let _arg_2;
        return append(singleton_1(defaultArg(map((desc_14) => {
            const message = toText(printf("Active Mode: %s"))(desc_14);
            return tag_52(ofArray([new Option_3(1, [new Color_IColor(7, [])]), new Option_3(0, [new Size_ISize(2, [])]), new Option_3(5, ["active-mode-indicator"]), new Option_3(4, [singleton(["style", {
                whiteSpace: "normal",
                height: "auto",
            }])])]), singleton(message));
        }, (_arg_2 = model.InteractionMode, (_arg_2.tag === 0) ? ((_arg_2.fields[0].tag === 1) ? (equals(model.ViewMode, new VisualizationViewMode(2, [])) ? "Screenshot - Select a viewport to capture it" : undefined) : ((_arg_2.fields[0].tag === 3) ? "Local diameter measurement" : ((_arg_2.fields[0].tag === 4) ? "Volume measurement" : ((_arg_2.fields[0].tag === 0) ? undefined : "Centerline distance measurement")))) : ((_arg_2.fields[0].tag === 1) ? "Moving measurement note" : ((_arg_2.fields[0].tag === 2) ? "Calipers measurement" : ((_arg_2.fields[0].tag === 3) ? "Diameter range measurement" : "Moving notes"))))), Helpers_nothing)), delay(() => {
            const canUserRequestReanalysis = defaultArg(map((user) => isAllowed(new Permission(27, []))(user.roles), model.MaybeCurrentUser), false);
            return (equals(model.PatientInstitutionDesignation, new InstitutionClinicalDesignation(1, [])) && canUserRequestReanalysis) ? singleton_1(submitForReanalysisButton) : empty_1();
        }));
    }))))))));
    return react.createElement("div", {
        className: "visualization-toolbar",
    }, ...children_6);
}

export function allMeasurementsCards(model, dispatch) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    const allButtons = toList(delay(() => append(singleton_1((dispatch_2) => (new Controls_dropdownButton(new DOMAttr(40, [(_arg_1) => {
        dispatch_2(new LocalMsg(14, [wrapLocalMsg(new LocalMsg_1(8, [equals(model.ViewMode, new VisualizationViewMode(0, []))]))]));
    }]), "Centerline Distance"))), delay(() => append(singleton_1((dispatch_3) => (new Controls_dropdownButton(new DOMAttr(40, [(_arg_2) => {
        dispatch_3(new LocalMsg(14, [wrapLocalMsg(new LocalMsg_1(9, [equals(model.ViewMode, new VisualizationViewMode(0, []))]))]));
    }]), "Diameter Range"))), delay(() => append(singleton_1((dispatch_4) => (new Controls_dropdownButton(new DOMAttr(40, [(_arg_3) => {
        dispatch_4(new LocalMsg(14, [wrapLocalMsg(new LocalMsg_1(10, [equals(model.ViewMode, new VisualizationViewMode(0, []))]))]));
    }]), "Local Diameter"))), delay(() => append(singleton_1((dispatch_5) => (new Controls_dropdownButton(new DOMAttr(40, [(_arg_4) => {
        dispatch_5(new LocalMsg(14, [wrapLocalMsg(new LocalMsg_1(11, [equals(model.ViewMode, new VisualizationViewMode(0, []))]))]));
    }]), "Volume"))), delay(() => (!equals(model.ViewMode, new VisualizationViewMode(0, [])) ? singleton_1((dispatch_1) => (new Controls_dropdownButton(new DOMAttr(40, [(_arg) => {
        dispatch_1(new LocalMsg(13, [wrapLocalMsg(new LocalMsg_2(4, []))]));
    }]), "Caliper"))) : empty_1())))))))))));
    return makeAllMeasurementCards(model, model.Measurements, (equals(model.InteractionMode, new InteractionMode(0, [new CommonInteractionMode(1, [])])) ? true : equals(model.InteractionMode, new InteractionMode(1, [new VisualizationTempInteractionMode(0, [])]))) ? (new CardMode(2, [])) : ((!canUserEditCustomReportData(model) ? true : ModelVisualizationTemp__get_hasModifiedSegmentations(model)) ? (new CardMode(1, [])) : (new CardMode(0, []))), allButtons, dispatchLocal);
}

export function staticNotesCard(model, dispatch) {
    return notesCard(model.NotesModel, (!canUserEditCustomReportData(model) ? true : ModelVisualizationTemp__get_hasModifiedSegmentations(model)) ? (new CardMode(1, [])) : (!equals(model.InteractionMode, new InteractionMode(0, [new CommonInteractionMode(0, [])])) ? (new CardMode(2, [])) : (new CardMode(0, []))), dispatch);
}

export function helpToolTipsCardOption(model, dispatch) {
    let children_10, children_2, children_8, children_48, children_16, children_22, children_28, children_34, children_40, children_46, children_62, children_54, children_60, children_100, children_68, children_74, children_80, children_86, children_92, children_98;
    if (model.ShowHelpTooltip) {
        let dicomTips;
        const children_50 = [table_1(singleton(new TableOption(2, [])), ofArray([(children_10 = [(children_2 = [react.createElement("th", {
            colSpan: 2,
        }, "CT Slice Viewport")], react.createElement("tr", {}, ...children_2)), (children_8 = [react.createElement("th", {}, "Action"), react.createElement("th", {}, "Controls")], react.createElement("tr", {}, ...children_8))], react.createElement("thead", {}, ...children_10)), (children_48 = [(children_16 = [react.createElement("td", {}, "Pan"), react.createElement("td", {}, "Shift + Left Click + Drag")], react.createElement("tr", {}, ...children_16)), (children_22 = [react.createElement("td", {}, "Window"), react.createElement("td", {}, "Click Window/Level button, then Left Click + Drag Horizontally")], react.createElement("tr", {}, ...children_22)), (children_28 = [react.createElement("td", {}, "Level"), react.createElement("td", {}, "Click Window/Level button, then Left Click + Drag Vertically")], react.createElement("tr", {}, ...children_28)), (children_34 = [react.createElement("td", {}, "Scroll Slice"), react.createElement("td", {}, "Middle Mouse Wheel (when mouse wheel action is set to scroll)")], react.createElement("tr", {}, ...children_34)), (children_40 = [react.createElement("td", {}, "Scroll Slice (Fast)"), react.createElement("td", {}, "Ctrl + Left Click + Drag Vertically")], react.createElement("tr", {}, ...children_40)), (children_46 = [react.createElement("td", {}, "Zoom"), react.createElement("td", {}, "Shift + Alt + Left Click + Drag")], react.createElement("tr", {}, ...children_46))], react.createElement("tbody", {}, ...children_48))]))];
        dicomTips = react.createElement("div", {}, ...children_50);
        let mapTips;
        const children_102 = [table_1(singleton(new TableOption(2, [])), ofArray([(children_62 = [(children_54 = [react.createElement("th", {
            colSpan: 2,
        }, "Map Viewports")], react.createElement("tr", {}, ...children_54)), (children_60 = [react.createElement("th", {}, "Action"), react.createElement("th", {}, "Controls")], react.createElement("tr", {}, ...children_60))], react.createElement("thead", {}, ...children_62)), (children_100 = [(children_68 = [react.createElement("td", {}, "Free Rotate"), react.createElement("td", {}, "Left Click + Drag")], react.createElement("tr", {}, ...children_68)), (children_74 = [react.createElement("td", {}, "CC/CCW Rotate"), react.createElement("td", {}, "Ctrl + Left Click + Drag")], react.createElement("tr", {}, ...children_74)), (children_80 = [react.createElement("td", {}, "Pan"), react.createElement("td", {}, "Shift + Left Click + Drag")], react.createElement("tr", {}, ...children_80)), (children_86 = [react.createElement("td", {}, "Zoom"), react.createElement("td", {}, "Middle Mouse Wheel (when mouse wheel action is set to zoom)")], react.createElement("tr", {}, ...children_86)), (children_92 = [react.createElement("td", {}, "Add Point Measurement"), react.createElement("td", {}, "Right Click on Map")], react.createElement("tr", {}, ...children_92)), (children_98 = [react.createElement("td", {}, "Clear Point Measurement"), react.createElement("td", {}, "Right Click Outside Map")], react.createElement("tr", {}, ...children_98))], react.createElement("tbody", {}, ...children_100))]))];
        mapTips = react.createElement("div", {}, ...children_102);
        return singleton(card(empty(), ofArray([header(empty(), ofArray([Header_title(empty(), singleton("Tool Tips")), Header_icon(singleton(new Common_GenericOption(1, [singleton(["style", {
            color: "inherit ",
        }])])), singleton(button(ofArray([new Option(17, [singleton(new HTMLAttr(158, ["Close"]))]), new Option(17, [ofArray([new DOMAttr(40, [(_arg) => {
            dispatch(new LocalMsg(20, []));
        }]), new HTMLAttr(159, ["button"])])]), new Option(0, [new Color_IColor(2, [])])]), singleton(icon_12(singleton(new Option_4(4, [singleton(["style", {
            fontWeight: "1000",
        }])])), singleton("x"))))))])), content_1(singleton(new Common_GenericOption(1, [singleton(["style", {
            padding: "0.5rem 1rem",
            margin: "1rem 0",
        }])])), ofArray([dicomTips, mapTips]))])));
    }
    else {
        return undefined;
    }
}

export function interactiveView(loadingStatus, imageData, model, dispatch) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    let viewportClassNames;
    const arg = equals(model.InteractionMode, new InteractionMode(0, [new CommonInteractionMode(1, [])])) ? " screenshot-ready" : "";
    viewportClassNames = toText(printf("layout-view-view-container%s"))(arg);
    const interactionProps = (vt) => (new InteractionModeProps(model.InteractionMode, VisualizationViewMode_toInteractionMode_Z71EA20FE(vt)(model.ViewMode)));
    const dispatchToggleHoverMsg = (h) => {
        const matchValue = model.InteractionMode;
        let matchResult;
        if (matchValue.tag === 0) {
            if (matchValue.fields[0].tag === 1) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                break;
            }
            case 1: {
                dispatchLocal(new LocalMsg(16, [wrapInboundMsg(new InboundMsg(2, [h]))]));
                break;
            }
        }
    };
    const meshViewport = (toDisplay, meshViewportLocation, model_1, dispatch_1) => {
        const dispatchLocal_1 = mkDispatchLocal(dispatch_1);
        const viewPortArgs = FSharpMap__get_Item(model_1.ViewportSelectedMap, meshViewportLocation);
        const onViewportResized = (meshViewportLocation.tag === 0) ? ((arg_2) => {
            dispatchLocal_1(new LocalMsg(8, [new InteractionMsg(arg_2)]));
        }) : ((value) => {
        });
        const showingPreviousOnly = equals(model_1.ViewMode, new VisualizationViewMode(0, [])) && equals(meshViewportLocation, Compare_previousStudyViewport);
        const target = showingPreviousOnly ? (new TargetStudy(1, [])) : (new TargetStudy(0, []));
        const measurementNotes = toArray(ofArray(toArray_1(map((entry) => {
            let arg_4;
            return new StaticLabel(entry.measurementIdUnified, (arg_4 = (!showingPreviousOnly ? entry.coreValues.currentValue : defaultArg(entry.coreValues.maybePreviousValue, "?")), toText(printf("%s: %s"))(entry.coreValues.name)(arg_4)), entry.coreValues.position[1], entry.coreValues.position[0].x, entry.coreValues.position[0].y, undefined, undefined, false, false);
        }, model_1.Measurements.activeMeasurement))));
        let staticNotesProps;
        const props = ModelNotes__Props_25828286(model_1.NotesModel, (arg_5) => {
            dispatchLocal_1(new LocalMsg(11, [arg_5]));
        });
        let matchResult_1;
        if (model_1.ViewMode.tag === 0) {
            if (contains(new VisualizationType(0, [meshViewportLocation]), Compare_previousMeshTypes, {
                Equals: equals,
                GetHashCode: safeHash,
            })) {
                matchResult_1 = 0;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                staticNotesProps = (new NotesProps(append_1([new StaticLabel("00000000-0000-0000-0000-000000000000", equals(meshViewportLocation, Compare_previousStudyViewport) ? "Previous Study" : "Current Study", 0, 0, 0, undefined, undefined, false, true)], props.staticLabels), props.wrapLines, props.worldLabels, props.onStaticLabelDragEnd));
                break;
            }
            default:
                staticNotesProps = props;
        }
        const props_3 = [new HTMLAttr(99, [toString(meshViewportLocation)]), new HTMLAttr(65, [viewportClassNames]), new DOMAttr(52, [(_arg) => {
            dispatchToggleHoverMsg(model_1.IsSliceScroll);
        }]), new DOMAttr(53, [(_arg_1) => {
            dispatchToggleHoverMsg(false);
        }]), ["style", keyValueList([toDisplay(new VisualizationType(0, [meshViewportLocation]))], 1)]];
        const children_1 = toList(delay(() => {
            let props_2;
            return append(singleton_1((props_2 = {
                viewportId: toString(meshViewportLocation),
                currentStudyMeshes: unwrap(map(Meshes_Current_3B5CE845, FSharpMap__get_Item(model_1.Meshes, meshViewportLocation))),
                previousStudyMeshes: unwrap(bind(Meshes_Previous_3B5CE845, FSharpMap__get_Item(model_1.Meshes, meshViewportLocation))),
                showPreviousStudyMapsOnly: showingPreviousOnly,
                selectedMap: viewPortArgs.map,
                showCenterline: model_1.DisplayCenterline,
                overlayPreviousStudyMaps: model_1.DisplayPreviousStudyMaps,
                interactionModeProps: interactionProps(new VisualizationType(0, [meshViewportLocation])),
                onViewportResized: onViewportResized,
                staticNotesProps: staticNotesProps,
                measurementNotesProps: new NotesProps(measurementNotes, (x_3) => x_3, new Array(0), (note) => {
                    dispatchLocal_1(new LocalMsg(19, [note]));
                }),
                cameraProps: ModelCamera_Props(viewPortArgs.planeAdjustment, (arg_6) => {
                    dispatchLocal_1(new LocalMsg(12, [arg_6]));
                }, model_1.CameraModel),
                calipersProps: ModelCalipers_Props_69A04C54(model_1.CalipersModel),
                centerlineMeasurementProps: ModelCenterlineMeasurement_Props(target, model_1.CenterlineMeasurementModel),
                screenshotProps: ModelScreenshot_Props_Z625F521((arg_7) => {
                    dispatchLocal_1(new LocalMsg(15, [arg_7]));
                }),
                slicePlaneProps: [ModelSlicePlane_Props_Z714BB56C(model_1.SlicePlaneModel)],
                anatomyOrientationProps: ModelAnatomyOrientation_Props_Z550008EC(model_1.AnatomyOrientationModel),
                pickedMapValueProps: ModelPickedMapValue_Props(model_1.PickedMapValueModel, new ViewportLocation(0, [meshViewportLocation]), (arg_8) => {
                    dispatchLocal_1(new LocalMsg(18, [arg_8]));
                }),
                meshViewportLocation: new ViewportLocation(0, [meshViewportLocation]),
                isSliceScroll: model_1.IsSliceScroll,
                onMeshSliceChange: (arg_11) => {
                    dispatchLocal_1(new LocalMsg(16, [wrapInboundMsg(new InboundMsg(1, [arg_11]))]));
                },
                isStentPlanning: false,
                showStentPlanningCenterlines: false,
                onRotationChange: (value_3) => {
                },
                eventNames: eventNames,
                selectedDicomView: new DicomViewMode(0, []),
                onVisualizationReady: (tupledArg) => {
                    dispatch_1(wrapOutboundMsg(new OutboundMsg(3, [tupledArg[0], tupledArg[1]])));
                },
                rawThreshold: model_1.RawThreshold,
                onRawThresholdChange: (arg_12) => {
                    dispatchLocal_1(new LocalMsg(26, [arg_12]));
                },
            }, react.createElement(MeshVisualization, props_2))), delay(() => (areMapSelectorsVisible(model_1) ? singleton_1(mkViewportToolPanel([mkMapSelect(dispatch_1, meshViewportLocation, model_1.ViewMode, model_1.AvailableMaps, viewPortArgs.map)])) : empty_1())));
        }));
        return react.createElement("div", keyValueList(props_3, 1), ...children_1);
    };
    const toDisplay_1 = (visualizationType) => {
        let matchValue_2;
        return new CSSProp(125, [(matchValue_2 = model.ViewMode, (matchValue_2.tag === 1) ? (equals(matchValue_2.fields[0], visualizationType) ? "block" : "none") : ((matchValue_2.tag === 0) ? (contains(visualizationType, Compare_previousMeshTypes, {
            Equals: equals,
            GetHashCode: safeHash,
        }) ? "block" : "none") : "block"))]);
    };
    let visualizationContainer;
    const matchValue_3 = model.ViewMode;
    switch (matchValue_3.tag) {
        case 1: {
            const props_8 = singleton(["style", {
                height: "100%",
            }]);
            visualizationContainer = ((children_6) => react.createElement("div", keyValueList(props_8, 1), ...children_6));
            break;
        }
        case 0: {
            const props_11 = ofArray([new HTMLAttr(65, ["layout-view-grid"]), ["style", {
                height: "100%",
                gridTemplateRows: "auto",
                gridTemplateColumns: "1fr 1fr",
            }]]);
            visualizationContainer = ((children_9) => react.createElement("div", keyValueList(props_11, 1), ...children_9));
            break;
        }
        default: {
            const props_5 = ofArray([new HTMLAttr(65, ["layout-view-grid"]), ["style", {
                gridTemplateRows: "1fr 1fr",
                gridTemplateColumns: "1fr 1fr",
            }]]);
            visualizationContainer = ((children_3) => react.createElement("div", keyValueList(props_5, 1), ...children_3));
        }
    }
    const children_21 = toList(delay(() => {
        let matchValue_4;
        return append((matchValue_4 = loadingStatus, (matchValue_4.tag === 2) ? singleton_1(Controls_spinner("Extracting...")) : ((matchValue_4.tag === 3) ? singleton_1(Controls_spinner("Rendering...")) : ((matchValue_4.tag === 0) ? singleton_1(Helpers_nothing) : ((matchValue_4.tag === 4) ? singleton_1(Helpers_nothing) : singleton_1(Controls_spinner("Downloading...")))))), delay(() => {
            let props_22, children_19, children_17, props_16, children_13, props_15, props_18;
            return singleton_1((props_22 = [new HTMLAttr(65, ["visualization-dynamic-height"]), ["style", {
                visibility: (loadingStatus.tag === 4) ? "visible" : "hidden",
            }]], (children_19 = [mkMainToolPanel(imageData, model, dispatch), (children_17 = [visualizationContainer(ofArray([(props_16 = [new HTMLAttr(65, [viewportClassNames]), new DOMAttr(52, [(_arg_2) => {
                dispatchToggleHoverMsg(true);
            }]), new DOMAttr(53, [(_arg_3) => {
                dispatchToggleHoverMsg(false);
            }]), ["style", keyValueList([toDisplay_1(new VisualizationType(1, []))], 1)]], (children_13 = [(props_15 = {
                viewportId: "DicomViewport",
                imageFiles: defaultArg(map(ImageData_StandardImageFiles__43A3F7B7, imageData), new Array(0)),
                maskFiles: defaultArg(map((dicom) => {
                    const matchValue_5 = model.ActiveSegmentation;
                    switch (matchValue_5.tag) {
                        case 1:
                            return ImageData_WallMasks__43A3F7B7(dicom);
                        case 2:
                            return ImageData_VisceralMasks__43A3F7B7(dicom);
                        default:
                            return ImageData_LumenMasks__43A3F7B7(dicom);
                    }
                }, imageData), new Array(0)),
                showMasks: model.ShowMasks,
                onSliceChange: (arg_15) => {
                    dispatchLocal(new LocalMsg(16, [wrapInboundMsg(new InboundMsg(0, [arg_15]))]));
                },
                onTouchStart: (e) => {
                    if (e.touches.length === 1) {
                        dispatchToggleHoverMsg(true);
                    }
                },
                onTouchEnd: (_arg_4) => {
                    dispatchToggleHoverMsg(false);
                },
                interactionModeProps: interactionProps(new VisualizationType(1, [])),
                screenshotProps: ModelScreenshot_Props_Z625F521((arg_16) => {
                    dispatchLocal(new LocalMsg(15, [arg_16]));
                }),
                isSliceScroll: model.IsSliceScroll,
                slicePlaneIndex: unwrap(model.SlicePlaneModel.Index),
                segmentationProps: model.SegmentationProps,
                slicingMode: new SlicingMode(0, []),
                lengthProps: new LengthPropsModel(toArray(model.DicomLengthMeasurementIds), model.LengthMeasurementState, () => {
                    dispatchLocal(new LocalMsg(29, []));
                }, (dicomLengthMeasurementId) => {
                    dispatchLocal(new LocalMsg(30, [dicomLengthMeasurementId]));
                }),
                activeWidget: unwrap(model.MaybeActiveWidget),
                imageLoader: model.ImageLoader,
                modifiedSegmentations: toArray_2(FSharpMap__get_Item(model.ModifiedSegmentations, model.ActiveSegmentation)),
                onVisualizationReady: (tupledArg_1) => {
                    dispatch(wrapOutboundMsg(new OutboundMsg(3, [tupledArg_1[0], tupledArg_1[1]])));
                },
                axialSegmentationChangedCallback: (i, data) => {
                    dispatchLocal(new LocalMsg(32, [i, data]));
                },
            }, react.createElement(DicomVisualization, props_15))], react.createElement("div", keyValueList(props_16, 1), ...children_13))), meshViewport(toDisplay_1, new MeshViewportLocation(0, []), model, dispatch), meshViewport(toDisplay_1, new MeshViewportLocation(1, []), model, dispatch), meshViewport(toDisplay_1, new MeshViewportLocation(2, []), model, dispatch)])), (props_18 = [["style", keyValueList(toList(delay(() => append(singleton_1(new CSSProp(395, ["100%"])), delay(() => append(singleton_1(new CSSProp(189, ["100%"])), delay(() => append(singleton_1(new CSSProp(291, ["relative"])), delay(() => append(singleton_1(new CSSProp(83, ["100%"])), delay(() => ((equals(model.InteractionMode, new InteractionMode(0, [new CommonInteractionMode(1, [])])) && !equals(model.ViewMode, new VisualizationViewMode(2, []))) ? singleton_1(new CSSProp(383, ["visible"])) : singleton_1(new CSSProp(383, ["hidden"]))))))))))))), 1)]], react.createElement("div", keyValueList(props_18, 1)))], react.createElement("div", {
                className: "viewports-height-correction",
            }, ...children_17))], react.createElement("div", keyValueList(props_22, 1), ...children_19))));
        }));
    }));
    return react.createElement("div", {}, ...children_21);
}

export function submitForReanalysisModal(model, dispatch) {
    const hideModal = (_arg) => {
        dispatch(wrapLocalMsg(new LocalMsg(33, [false])));
    };
    return modal(singleton(new Option_5(1, [model.SubmitReanalysisModalVisible])), ofArray([background(singleton(new Common_GenericOption(1, [singleton(new DOMAttr(40, [hideModal]))])), empty()), Card_card(empty(), ofArray([Card_head(empty(), singleton("Submit For Re-Analysis")), Card_body(empty(), ofArray([react.createElement("div", {}, "Are you sure you want to submit the updated segmentations for re-analysis?"), react.createElement("div", {}, "You won\'t be able to view or make changes to this study until re-analysis is complete.")])), Card_foot(empty(), ofArray([button(ofArray([new Option(0, [new Color_IColor(6, [])]), new Option(17, [singleton(new DOMAttr(40, [(_arg_1) => {
        dispatch(wrapLocalMsg(new LocalMsg(34, [map_1((activeSegmentation) => mkManagedUpload(model, activeSegmentation), ActiveSegmentation_get_all())])));
    }]))])]), singleton("Submit")), button(singleton(new Option(17, [singleton(new DOMAttr(40, [hideModal]))])), singleton("Cancel"))]))]))]));
}

export function reanalysisSubmitted(model, dispatch) {
    let children, s_1;
    return modal(singleton(new Option_5(1, [equals(model.SelectedStudy.status, new Common_StudyStatus(5, []))])), ofArray([background(empty(), empty()), Card_card(empty(), ofArray([Card_head(empty(), singleton("Study Has Been Submitted For Re-Analysis")), Card_body(empty(), singleton((children = [(s_1 = "This study has been submitted for re-analysis and will be locked until re-analysis is complete. You will now be returned to the study page.", s_1)], react.createElement("div", {}, ...children)))), Card_foot(empty(), singleton(button(ofArray([new Option(0, [new Color_IColor(6, [])]), new Option(17, [singleton(new DOMAttr(40, [(_arg) => {
        dispatch(wrapOutboundMsg(new OutboundMsg(2, [])));
    }]))])]), singleton("Ok"))))]))]));
}

export function segmentationLockWarningModal(model, dispatch) {
    let children_8, children_2, s_2, children_4, s_3, children_6, s_4;
    return modal(singleton(new Option_5(1, [model.SegmentationLockWarningModalVisible])), singleton(Card_card(empty(), ofArray([Card_head(empty(), singleton("Segmentation Warning")), Card_body(empty(), singleton(content_2(empty(), singleton((children_8 = [react.createElement("li", {}, "Making segmentations will lock out measurements and report generation."), (children_2 = [(s_2 = "Segmentations are only valid within this session — you must submit them for reanalysis to keep them.", s_2)], react.createElement("li", {}, ...children_2)), (children_4 = [(s_3 = "Refresh the page to reset any segmentations created and unlock the measurements and report generation functionality", s_3)], react.createElement("li", {}, ...children_4)), (children_6 = [(s_4 = "Do not leave the system unattended once you start to create segmentations. If you are automatically logged out by the system after 10 minutes of inactivity, all segmentations will be reset.", s_4)], react.createElement("li", {}, ...children_6))], react.createElement("ul", {}, ...children_8)))))), Card_foot(empty(), singleton(button(ofArray([new Option(0, [new Color_IColor(6, [])]), new Option(17, [singleton(new DOMAttr(40, [(_arg) => {
        dispatch(wrapLocalMsg(new LocalMsg(37, [false])));
        dispatch(wrapLocalMsg(new LocalMsg(38, [true])));
    }]))])]), singleton("Acknowledge"))))]))));
}

export function segmentationDiscardWarningModal(model, dispatch) {
    const hideModal = (_arg) => {
        dispatch(wrapLocalMsg(new LocalMsg(39, [false])));
    };
    return modal(singleton(new Option_5(1, [model.SegmentationDiscardModalVisible])), ofArray([background(singleton(new Common_GenericOption(1, [singleton(new DOMAttr(40, [hideModal]))])), empty()), Card_card(empty(), ofArray([Card_head(empty(), singleton("Discard Segmentation Changes")), Card_body(empty(), ofArray([react.createElement("div", {}, "Any segmentation changes that have not been submitted for re-analysis will be lost."), react.createElement("div", {}, "Report and screenshot generation will be re-enabled.")])), Card_foot(empty(), ofArray([button(ofArray([new Option(0, [new Color_IColor(8, [])]), new Option(17, [singleton(new DOMAttr(40, [(_arg_1) => {
        dispatch(wrapLocalMsg(new LocalMsg(40, [])));
    }]))])]), singleton("Acknowledge")), button(singleton(new Option(17, [singleton(new DOMAttr(40, [hideModal]))])), singleton("Cancel"))]))]))]));
}

export function segmentationApprovalRequiredModal(model, dispatch) {
    let s_1;
    return modal(singleton(new Option_5(1, [model.SegmentationApprovalModalVisible])), singleton(Card_card(empty(), ofArray([Card_head(empty(), singleton("Segmentation Verification")), Card_body(empty(), singleton(content_2(empty(), singleton((s_1 = "In order to see other visualization maps, you need to approve the existing segmentation using the Approve Segmentation button in the side panel.", s_1))))), Card_foot(empty(), singleton(button(ofArray([new Option(0, [new Color_IColor(6, [])]), new Option(17, [singleton(new DOMAttr(40, [(_arg) => {
        dispatch(wrapLocalMsg(new LocalMsg(41, [false])));
    }]))])]), singleton("Understood"))))]))));
}

export function customReportSegementationReviewConfirmationModal(model, dispatch) {
    let children_4, children_2, s_2;
    return modal(singleton(new Option_5(1, [model.CustomReportSegmentationConfirmationModalVisible])), singleton(Card_card(empty(), ofArray([Card_head(empty(), singleton("Report Generation")), Card_body(empty(), singleton((children_4 = [react.createElement("p", {}, "Please ensure you have reviewed the segmentations and the quality of all measurements made."), (children_2 = [(s_2 = "If you have not, click the Cancel button to return to the visualization and review or adjust the segmentations and measurements.", s_2)], react.createElement("p", {}, ...children_2))], react.createElement("div", {}, ...children_4)))), Card_foot(empty(), ofArray([button(ofArray([new Option(0, [new Color_IColor(6, [])]), new Option(17, [singleton(new DOMAttr(40, [(_arg_1) => {
        dispatch(wrapOutboundMsg(new OutboundMsg(1, [model.SelectedStudy, model.CustomReportData])));
    }]))])]), singleton("Generate Report")), button(singleton(new Option(17, [singleton(new DOMAttr(40, [(_arg) => {
        dispatch(wrapLocalMsg(new LocalMsg(44, [false])));
    }]))])), singleton("Cancel"))]))]))));
}

export function view(loadingStatus, imageData, model, dispatch) {
    const children = toList(delay(() => append(singleton_1(interactiveView(loadingStatus, imageData, model, dispatch)), delay(() => append(equals(model.PatientInstitutionDesignation, new InstitutionClinicalDesignation(1, [])) ? append(singleton_1(submitForReanalysisModal(model, dispatch)), delay(() => append(singleton_1(reanalysisSubmitted(model, dispatch)), delay(() => append(singleton_1(segmentationLockWarningModal(model, dispatch)), delay(() => append(singleton_1(segmentationDiscardWarningModal(model, dispatch)), delay(() => append(singleton_1(customReportSegementationReviewConfirmationModal(model, dispatch)), delay(() => singleton_1(segmentationApprovalRequiredModal(model, dispatch)))))))))))) : empty_1(), delay(() => append(singleton_1(notesModal(model.NotesModel, (arg_1) => {
        dispatch(wrapLocalMsg(new LocalMsg(11, [arg_1])));
    })), delay(() => append(singleton_1(deleteMeasurementModal(model, model.Measurements, (arg_2) => {
        dispatch(wrapLocalMsg(arg_2));
    })), delay(() => singleton_1(screenshotModal(model.ScreenshotModel, (arg_4) => {
        dispatch(wrapLocalMsg(new LocalMsg(15, [arg_4])));
    }, !canUserEditCustomReportData(model)))))))))))));
    return react.createElement(react.Fragment, {}, ...children);
}

